import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useAdmin() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['admin', 'me'],
    queryFn: api.getAdminMe,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false,
  });

  return {
    isAdmin: data?.isAdmin ?? false,
    isLoading,
    error,
  };
}
